import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { readOnlyTextFieldInputProps } from './constants';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  alignRight: {
    textAlign: 'right',
  },
}));

export interface VseNumberFieldProps {
  readOnly?: boolean,
  min?: number,
  step?: number,
  fixedPoint?: number,
  value?: string | number,
}

export const VseNumberField = (props: VseNumberFieldProps & TextFieldProps) => {
  const classes = useStyles();
  const {
    readOnly = false,
    min,
    step,
    fixedPoint = 0,
    value = '',
    InputProps,
    inputProps,
    ...others
  } = props;
  const readOnlyInputProps: TextFieldProps['InputProps'] = {
    ...InputProps,
    ...readOnlyTextFieldInputProps
  };
  const readOnlyinputProps: TextFieldProps['inputProps'] = {
    ...inputProps,
    className: clsx(classes.alignRight, inputProps && inputProps.className),
  }
  const editinputProps: TextFieldProps['inputProps'] = {
    ...readOnlyinputProps,
    min: min,
    step: step,
  };
  const type: TextFieldProps['type'] = readOnly ? 'text' : 'number';
  const numValue = typeof value === 'number' ? value : Number.parseFloat(value);

  return (
    <TextField
      {...others}
      type={type}
      value={Number.isNaN(numValue) ? '' : numValue.toFixed(fixedPoint)}
      InputProps={readOnly ? readOnlyInputProps : InputProps}
      inputProps={readOnly ? readOnlyinputProps : editinputProps}
    />);
};
